import dateFormat from "date-format";

import Navbar from "@/components/template-components/navbar";
import AppCtaButtonMobile from "@/components/app-cta/mobile-button";
import AccountButtons from "@/components/account-buttons";

import { PAGES, TRANSPARENT_PNG } from "@/common/consts";
import { isClientSide } from "@/common/functions";
import data from "./data";
import { mapGetters } from "vuex";
/**
 * HEADER
 *
 * The header.
 *
 */
export default {
	name: "Header",
	components: {
		Navbar,
		AppCtaButtonMobile,
		AccountButtons,
	},
	computed: {
		...mapGetters("navigationChecks", ["isPersistentSearch"]),
		...mapGetters("device", [
			"isSmallDevice",
			"isSmallOrMediumDevice",
			"isExtraLargeDevice",
		]),
		isWordCookiesPage() {
			return this.$route.name === PAGES.WORDCOOKIES;
		},
		isMobileMenuOpen() {
			return this.$store.state.navigation.burgerActive;
		},
		mobileHeaderTop() {
			return {
				top: `${this.currentHeaderScroll}px`,
			};
		},
		desktopHeaderTop() {
			if (this.isSmallOrMediumDevice)
				return {
					top: `${Math.min(
						this.lowestScroll,
						Math.max(this.currentHeaderScroll, this.highestScroll)
					) + this.$store.state.device.topAdHeight}px`,
				};
			else
				return {
					top: `${this.currentHeaderScroll +
						this.$store.state.device.topAdHeight}px`,
				};
		},
		headerTopIndent() {
			// Since we're talking about pushing the header upwards, 'highestScroll' is an increasingly-negative number as the user scrolls downwards, and 'lowestScroll' is an increasingly-positive number as the user scrolls upwards.
			const newScrollY = this.scrollY;
			let newHeaderScroll;
			const searchOffsetDelay = this.$store.state.device
				.searchHeaderMobileHeight;
			if (newScrollY > 0) {
				let delta = this.currentWindowScroll - newScrollY;
				newHeaderScroll = this.currentHeaderScroll + delta;
				let highestScrollMargin = this.isPersistentSearch
					? this.highestScroll
					: this.highestScroll - searchOffsetDelay;
				if (newHeaderScroll < highestScrollMargin) {
					newHeaderScroll = highestScrollMargin;
				} else if (newHeaderScroll > this.lowestScroll) {
					newHeaderScroll = this.lowestScroll;
				}
			} else {
				newHeaderScroll = 0;
			}
			if (this.isMobileMenuOpen) {
				newHeaderScroll = 0;
			}
			this.currentWindowScroll = newScrollY;
			this.currentHeaderScroll = newHeaderScroll;
			this.$store.commit(
				"device/UPDATE_VISIBLE_HEADER_HEIGHT",
				Math.abs(this.highestScroll) +
					newHeaderScroll +
					searchOffsetDelay
			);

			if (this.isSmallDevice) {
				return this.mobileHeaderTop;
			} else {
				return this.desktopHeaderTop;
			}
		},
		highestScroll() {
			return -this.$store.state.device.headerHeight;
		},
		isNeedToShowCtaButton() {
			const lastVisitedTime = this.$store.getters.lastVisited || 0;

			// If the value is 0, it means the last visited cookie was never set, i.e. it's their first time here.
			if (lastVisitedTime === 0) return true;

			const currentTime = new Date();

			const lv = dateFormat.parse(
				dateFormat.ISO8601_WITH_TZ_OFFSET_FORMAT,
				lastVisitedTime
			);

			const diff = currentTime - lv;
			const max = 7 * 24 * 60 * 60 * 1000; // 7 Days,  in miliseconds.

			return diff > max;
		},
		isCtaButtonShow() {
			return this.isSmallOrMediumDevice || this.isGetTheAppPage;
		},
		scrollY() {
			return this.$store.state.device.scrollY;
		},
		showBorder() {
			if (this.isPersistentSearch) {
				return false;
			}
			return true;
		},
		logoImage() {
			if (!isClientSide()) {
				return "";
			}

			return this.isSmallDevice
				? "/static-wf/images/ic_wfw_header.webp"
				: "/static-wf/images/ic_wfw_complete.webp";
		},
		logoBackupImage() {
			if (!isClientSide()) {
				return TRANSPARENT_PNG;
			}

			return this.isSmallDevice
				? "/static-wf/images/ic_wfw_header.png"
				: "/static-wf/images/ic_wfw_complete.png";
		},
	},
	methods: {
		dispatchGaEvent() {
			this.$store.dispatch("trackEvent", {
				eventCategory: "Header",
				eventAction: "Click EN WF Logo navigation element",
				eventLabel: "EN WF Logo",
				eventID: 2,
			});
		},
	},
	mounted() {
		if (!this.resizeObserver && typeof ResizeObserver === "function") {
			this.resizeObserver = new ResizeObserver((entries) => {
				const header = entries[0];
				const box = Array.isArray(header.contentBoxSize)
					? header.contentBoxSize[0]
					: header.contentBoxSize;
				const height = box?.blockSize || header.contentRect.height;

				this.$store.commit("device/SET_HEADER_HEIGHT", height);
			});

			this.resizeObserver.observe(this.$refs.header);
		}
	},
	destroyed() {
		this.resizeObserver?.unobserve(this.$refs.header);
		this.resizeObserver = null;
	},
	data,
};
